export default __webpack_public_path__ + "static/media/product-09 (1).30ee8e32.jpg";